import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 代理招标 - 代理服务费
 */
export default {
  path: 'service-fee',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '代理服务费',
    icon: 'icon-side-dailifuwufeiguanli',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [{ companyType: companyTypeDict.ENTERPRISE.value }],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
  roles: [
    platformFunctionModuleDict.AGENCY.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 服务费收取
    {
      path: 'charge',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '服务费收取',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
      roles: [
        platformFunctionModuleDict.AGENCY.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 收取列表
        {
          path: 'list',
          name: `AgencyServiceFeeChargeList`,
          component: '/agency-views/agency-service-fee/charge/list',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '收取列表',
            cache: true,
            hidden: true,
            pageComponentName: 'AgencyServiceFeeChargeList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
          roles: [
            platformFunctionModuleDict.AGENCY.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 新增收取
        {
          path: ':id?/form',
          name: `AgencyServiceFeeChargeForm`,
          component: '/agency-views/agency-service-fee/charge/form',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '新增收取',
            hidden: true,
            needFormKey: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
          roles: [
            platformFunctionModuleDict.AGENCY.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 收取详情
        {
          path: ':id/detail',
          name: `AgencyServiceFeeChargeDetail`,
          component: '/agency-views/agency-service-fee/charge/detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '收取详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
          roles: [
            platformFunctionModuleDict.AGENCY.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    },

    // 服务费收入
    {
      path: 'income',
      type: menuTypeDict.DIRECTORY.value,
      meta: {
        title: '服务费收入',
        layout: 'DefaultLayout'
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
      roles: [
        platformFunctionModuleDict.AGENCY.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: [],

      children: [
        // 收入列表
        {
          path: 'list',
          name: `AgencyServiceFeeIncomeList`,
          component: '/agency-views/agency-service-fee/income/list',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '收入列表',
            cache: true,
            hidden: true,
            pageComponentName: 'AgencyServiceFeeIncomeList'
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
          roles: [
            platformFunctionModuleDict.AGENCY.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        },

        // 收入详情
        {
          path: ':id/detail',
          name: `AgencyServiceFeeIncomeDetail`,
          component: '/agency-views/agency-service-fee/income/detail',
          type: menuTypeDict.MENU.value,
          meta: {
            title: '收入详情',
            hidden: true
          },
          applicableCompanyTypes: [
            { companyType: companyTypeDict.ENTERPRISE.value }
          ],
          platformAlias: [],
          applicableCompanyIdentities: [workbenchServiceDict.AGENCY.value],
          roles: [
            platformFunctionModuleDict.AGENCY.right,
            platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
          ],
          superviseInstitutions: []
        }
      ]
    }
  ]
}
